import { Enum } from './Enum';

export class MemberEngagementLevel extends Enum {
  translationKey = 'memberEngagementLevel';

  static asArray: MemberEngagementLevel[] = [];

  static byKey: { [name: string]: MemberEngagementLevel } = {};

  static readonly LOW = new MemberEngagementLevel('LOW');

  static readonly MEDIUM = new MemberEngagementLevel('MEDIUM');

  static readonly HIGH = new MemberEngagementLevel('HIGH');

  constructor(public readonly value: string) {
    super();
    MemberEngagementLevel.asArray.push(this);
    MemberEngagementLevel.byKey[value] = this;
  }

  static getColor(level: MemberEngagementLevel) {
    if (MemberEngagementLevel.LOW === level) return 'error';
    if (MemberEngagementLevel.MEDIUM === level) return 'primary';
    if (MemberEngagementLevel.HIGH === level) return 'secondary';
    return undefined;
  }
}

export default MemberEngagementLevel;
